import { components } from "src/strapi/schema";
import { strapiRepository } from "src/strapi/strapiRepository";
import { cn } from "src/lib/utils";

export const ContactBox = ({
  contact,
  fontSize = "small",
}: {
  fontSize?: "big" | "small";
  contact: components["schemas"]["Employee"];
}) => {
  const { getImageUrl } = strapiRepository;

  return (
    <div className={"relative flex aspect-video flex-col items-start"}>
      {contact.photo && (
        <img
          className={"absolute size-full object-cover object-right-top"}
          src={getImageUrl(contact.photo)}
          alt={contact.name}
        />
      )}
      <div className={"absolute flex w-full flex-col items-start p-3"}>
        <h2
          className={cn(
            "bg-foreground/90 w-fit px-2 py-0.5 text-xl font-bold text-white",
            {
              "lg:text-3xl": fontSize === "big",
            },
          )}
        >
          {contact.name}
        </h2>
        <p
          className={cn(
            "bg-foreground/90 w-fit max-w-[55%] px-2 py-0.5 text-sm text-white md:max-w-fit",
            {
              "md:max-w-[50%] lg:text-base": fontSize === "big",
            },
            {
              "max-w-[50%] text-xs md:max-w-[55%] md:text-sm 2xl:max-w-[60%]":
                fontSize === "small",
            },
          )}
        >
          {contact.role}
        </p>
        <p
          className={cn(
            "bg-foreground/90 w-fit px-2 py-0.5 text-sm text-white/90",
            {
              "text-xs": fontSize === "small",
            },
          )}
        >
          {contact.email}
        </p>
        {/*tel*/}
        <p
          className={"bg-foreground/90 w-fit px-2 py-0.5 text-sm text-white/90"}
        >
          {contact.phone}
        </p>
      </div>
    </div>
  );
};
